module.exports = __webpack_public_path__ + "8eeac42503c4bb3c57b64a2cb317f132.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-2.png
// module id = 1789
// module chunks = 0